// import {http} from "@/cbd-migration/importSettings";
// import HttpHandler from "@/handler/HttpHandler";
import http from '@/util/http';
// const http = new HttpHandler();

export default {
  getMenu() {
    return http.get('/aaas-system/getLeftMenuList')
  }
}
